// Types
import { VesselDetail } from '@schemas/services';

export const summaryMock: VesselDetail[] = [
  {
    eoyRating: { A: 2, B: 10, C: 15, D: 10, E: 18 },
    typeId: 3,
    type: 'Bulk Carrier',
    ytdRating: { A: 5, B: 10, C: 15, D: 10, E: 15 },
  },
  {
    eoyRating: { A: 7, B: 3, C: 2, D: 1, E: 2 },
    typeId: 2,
    type: 'Cargo Ship',
    ytdRating: { A: 10, B: 3, C: 2, D: 0, E: 0 },
  },
  {
    eoyRating: { A: 2, B: 2, C: 0, D: 0, E: 0 },
    typeId: 1,
    type: 'Container',
    ytdRating: { A: 2, B: 1, C: 1, D: 0, E: 0 },
  },
  {
    eoyRating: { A: 2, B: 0, C: 0, D: 1, E: 0 },
    typeId: 4,
    type: 'Cargo Ship',
    ytdRating: { A: 2, B: 0, C: 1, D: 0, E: 0 },
  },
  {
    eoyRating: { A: 0, B: 1, C: 0, D: 0, E: 0 },
    typeId: 8,
    type: 'LNG Carrier',
    ytdRating: { A: 1, B: 0, C: 0, D: 0, E: 0 },
  },
];
